import {
  approvalIsCurrent,
  type PlanStep,
  type WorkPlan,
} from "../../../../skills/leadcue-reply/scripts/lib/work-plan.ts";
import { ExternalLinkIcon } from "../icons.tsx";

export const approveLabel = (again: boolean): string => (again ? "Approve again" : "Approve draft");

export function stepApproveLabel(step: PlanStep): string {
  const input = step.input;
  if (input.kind === "reply") return approveLabel(false);
  if (input.kind !== "connector") return "Approve";
  switch (input.action.type) {
    case "meeting_create":
      return "Approve invite";
    case "unsubscribe":
      return "Approve unsubscribe";
    case "block":
      return "Approve block";
  }
}

/** Approval records intent only; sending remains a separate explicit action. */
export function useStepApproval(input: {
  run: (work: () => Promise<unknown>) => Promise<void>;
  commandRequest: (stepId: string, action: "approve") => Promise<unknown>;
}) {
  return {
    approve: (step: PlanStep, given?: () => Promise<unknown>) => {
      void input.run(given ?? (() => input.commandRequest(step.id, "approve")));
    },
  };
}

export function ApprovedReplyActions(props: {
  plan: WorkPlan;
  step: PlanStep;
  sending: boolean;
  bisonUrl: string | null;
  onReport: () => void;
}) {
  const { step, bisonUrl } = props;
  if (step.input.kind !== "reply" || step.state !== "approved" || props.sending) return null;
  if (!approvalIsCurrent(props.plan, step)) return null;
  return (
    <div className="lcr-actions">
      {bisonUrl && (
        <a href={bisonUrl} target="_blank" rel="noreferrer">
          <ExternalLinkIcon size={16} /> Open Bison
        </a>
      )}
      <button type="button" onClick={props.onReport}>
        I sent it in Bison
      </button>
    </div>
  );
}
